import { useState, useEffect, useRef } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

const authHeaders = () => ({ 
  'Content-Type': 'application/json', 
  Authorization: `Bearer ${localStorage.getItem('cms_token') || ''}` 
})

export default function ResearchActivities() {
  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [editId, setEditId] = useState(null)
  const [saving, setSaving] = useState(false)
const [checkinStats, setCheckinStats] = useState({})
  const [qrcodeModal, setQrcodeModal] = useState({ visible: false, title: '', id: '' })
  // 签到码弹窗
  const handleCheckinCode = (activity) => {
    setQrcodeModal({ visible: true, title: activity.title, id: activity.id })
  }
  const closeQrcode = () => setQrcodeModal({ visible: false, title: '', id: '' })

  const [uploading, setUploading] = useState(false)
  const fileInputRef = useRef(null)
  const [form, setForm] = useState({
    title: '',
    type: '职业探索',
    activityDate: '',
    location: '',
    price: 0,
    maxParticipants: 30,
    ageRange: '4-12',
    coverImage: '',
    description: '',
    highlights: ''
  })

  useEffect(() => {
    loadActivities()
  }, [])

  const loadActivities = async () => {
    try {
      const activityRes = await fetch(`${API}/study-activities/admin/list`, { headers: authHeaders() })
      const activityJson = await activityRes.json()
      
      const merged = activityJson.success ? (activityJson.data || []) : []
      
      setActivities(merged)
      loadCheckinStats(merged)
    } catch (err) {
      console.error('加载失败:', err)
    }
    setLoading(false)
  }
  // 加载签到统计
  const loadCheckinStats = (activities) => {
    if (!activities || activities.length === 0) return;
    const stats = {};
    let done = 0;
    activities.forEach(a => {
      fetch('/cms/api/checkin/' + a.id + '/status')
        .then(r => r.json())
        .then(d => {
          if (d.success) stats[a.id] = { total: d.data.total, checkedIn: d.data.checkedIn };
          done++;
          if (done === activities.length) setCheckinStats({...stats});
        })
        .catch(() => {
          done++;
          if (done === activities.length) setCheckinStats({...stats});
        });
    });
  };


  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    setUploading(true)
    try {
      const fd = new FormData()
      fd.append('file', file)
      const res = await fetch(`${API}/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('cms_token') || ''}` },
        body: fd
      })
      const data = await res.json()
      if (data.success) {
        setForm({...form, coverImage: data.data.url})
      } else {
        alert(data.error || '上传失败')
      }
    } catch (err) {
      alert('上传失败: ' + err.message)
    }
    setUploading(false)
    if (fileInputRef.current) fileInputRef.current.value = ''
  }

  const handleSubmit = async () => {
    if (!form.title) {
      alert('请填写活动名称')
      return
    }
    setSaving(true)
    try {
      const payload = {
        title: form.title,
        type: form.type,
        activityDate: form.activityDate,
        location: form.location,
        price: parseFloat(form.price) || 0,
        maxParticipants: parseInt(form.maxParticipants) || 30,
        ageRange: form.ageRange,
        coverImage: form.coverImage,
        description: form.description,
        highlights: form.highlights,
        enableOnlinePayment: form.enableOnlinePayment ? 1 : 0
      }
      const url = editId ? `${API}/study-activities/${editId}` : `${API}/study-activities`
      const method = editId ? 'PUT' : 'POST'
      const res = await fetch(url, { method, headers: authHeaders(), body: JSON.stringify(payload) })
      const data = await res.json()
      if (data.success) {
        setShowModal(false)
        loadActivities()
      } else {
        alert(data.error || '保存失败')
      }
    } catch (e) { 
      alert('保存失败') 
    }
    setSaving(false)
  }

  const handlePublish = async (id) => {
    if (!confirm('确认发布此活动？')) return
    const res = await fetch(`${API}/study-activities/${id}/publish`, { method: 'PUT', headers: authHeaders() })
    const data = await res.json()
    if (data.success) loadActivities()
    else alert(data.error || '发布失败')
  }

  const handleDelete = async (id) => {
    if (!confirm('确认删除此活动？删除后无法恢复！')) return
    const res = await fetch(`${API}/study-activities/${id}`, { method: 'DELETE', headers: authHeaders() })
    const data = await res.json()
    if (data.success) loadActivities()
    else alert(data.error || '删除失败')
  }

  const handleUnpublish = async (id) => {
    if (!confirm('确认下架此活动？下架后小程序将不再显示')) return
    const res = await fetch(`${API}/study-activities/${id}/unpublish`, { method: 'PUT', headers: authHeaders() })
    const data = await res.json()
    if (data.success) loadActivities()
    else alert(data.error || '下架失败')
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
        <h2>📚 活动管理</h2>
        <button onClick={() => { setEditId(null); setForm({ title: '', type: '职业探索', activityDate: '', location: '', price: 0, maxParticipants: 30, ageRange: '4-12', coverImage: '', description: '', highlights: '', enableOnlinePayment: false }); setShowModal(true); }}
          style={{ background: '#1890ff', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 4, cursor: 'pointer' }}>
          + 新建活动
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>加载中...</div>
      ) : activities.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无活动，点击上方按钮创建</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
          <thead>
            <tr style={{ background: '#f5f5f5' }}>
              <th style={{ padding: 12, textAlign: 'left' }}>活动名称</th>
              <th style={{ padding: 12, textAlign: 'left' }}>类型</th>
              <th style={{ padding: 12, textAlign: 'left' }}>日期</th>
              <th style={{ padding: 12, textAlign: 'left' }}>价格</th>
              <th style={{ padding: 12, textAlign: 'center', fontSize: 13 }}>机构分成(%)</th>
              <th style={{ padding: 12, textAlign: 'left' }}>支付</th>
              <th style={{ padding: 12, textAlign: 'left' }}>状态</th>
              <th style={{ padding: 12, textAlign: 'center' }}>签到</th>
              <th style={{ padding: 12, textAlign: 'center' }}>操作</th>
            </tr>
          </thead>
          <tbody>
            {activities.map(a => (
              <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: 12 }}>{a.title}</td>
                <td style={{ padding: 12 }}>{a.type}</td>
                <td style={{ padding: 12 }}>{a.date || a.activity_date || '-'}</td>
                <td style={{ padding: 12 }}>¥{a.price}</td>

                <td style={{ padding: 12, textAlign: 'center' }}>
                  <input type="number" min="0" max="100"
                    value={a.default_commission ?? ''}
                    onChange={e => {
                      const val = e.target.value === '' ? null : parseInt(e.target.value) || 0;
                      fetch(API + '/study-activities/' + a.id, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json', 'Authorization': '***' + getToken() },
                        body: JSON.stringify({ ...a, default_commission: val || null })
                      }).then(r => r.json()).then(json => {
                        if (json.success) { a.default_commission = val; loadActivities(); }
                      }).catch(e => { console.error(e) });
                    }}
                    placeholder="50"
                    style={{ width: 52, padding: '3px 4px', textAlign: 'center',
                      border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 12 }} />
                </td>
                <td style={{ padding: 12 }}>
                  {a.enable_online_payment === 1
                    ? <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: '#e6f4ff', color: '#1890ff' }}>线上</span>
                    : <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: '#f5f5f5', color: '#999' }}>线下</span>
                  }
                </td>
                <td style={{ padding: 12 }}>
                  <span style={{ 
                    padding: '2px 8px', 
                    borderRadius: 4, 
                    background: a.status === 'published' ? '#d4edda' : '#fff3cd',
                    color: a.status === 'published' ? '#155724' : '#856404'
                  }}>
                    {a.status === 'published' ? '已发布' : '草稿'}
                  </span>
                </td>
                <td style={{ padding: 12, textAlign: 'center', fontSize: 13, color: '#666' }}>
                  {checkinStats[a.id] ? (
                    <span>{checkinStats[a.id].checkedIn}/{checkinStats[a.id].total}</span>
                  ) : (
                    <span style={{ color: '#bbb' }}>-</span>
                  )}
                </td>
                <td style={{ padding: 12, textAlign: 'center' }}>
                  <button onClick={() => { setEditId(a.id); setForm({ title: a.title, type: a.type, activityDate: a.activity_date, location: a.location, price: a.price, maxParticipants: a.max_participants, ageRange: a.age_range, coverImage: a.cover_image, description: a.description, highlights: a.highlights, enableOnlinePayment: a.enable_online_payment === 1 || a.enable_online_payment === '1' }); setShowModal(true); }}
                    style={{ marginRight: 8, padding: '4px 12px', border: '1px solid #d9d9d9', background: '#fff', cursor: 'pointer' }}>编辑</button>
                  <a href={'https://api.boxiaotu.cn/api/checkin/qrcode/' + a.id} target='_blank' style={{ marginRight: 8, padding: '4px 12px', border: '1px solid #722ed1', background: '#f9f0ff', color: '#722ed1', cursor: 'pointer', textDecoration: 'none', display: 'inline-block' }}>签到码</a>

                  {a.status !== 'published' ? (
                    <button onClick={() => handlePublish(a.id)} style={{ marginRight: 8, padding: '4px 12px', border: '1px solid #1890ff', background: '#fff', color: '#1890ff', cursor: 'pointer' }}>发布</button>
                  ) : (
                    <button onClick={() => handleUnpublish(a.id)} style={{ marginRight: 8, padding: '4px 12px', border: '1px solid #faad14', background: '#fff', color: '#faad14', cursor: 'pointer' }}>下架</button>
                  )}
                  <button onClick={() => handleDelete(a.id)} style={{ padding: '4px 12px', border: '1px solid #ff4d4f', background: '#fff', color: '#ff4d4f', cursor: 'pointer' }}>删除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', padding: 24, borderRadius: 8, width: 600, maxHeight: '80vh', overflow: 'auto' }}>
            <h3 style={{ marginTop: 0 }}>{editId ? '编辑活动' : '新建活动'}</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>活动名称 *</label>
                <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>活动类型</label>
                <select value={form.type} onChange={e => setForm({...form, type: e.target.value})} style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }}>
                  <option value="职业探索">职业探索</option>
                  <option value="科技创意">科技创意</option>
                  <option value="艺术体验">艺术体验</option>
                  <option value="户外拓展">户外拓展</option>
                  <option value="文化体验">文化体验</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>活动日期</label>
                <input type="date" value={form.activityDate} onChange={e => setForm({...form, activityDate: e.target.value})} style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>活动地点</label>
                <input value={form.location} onChange={e => setForm({...form, location: e.target.value})} style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>价格 (元)</label>
                <input type="number" value={form.price} onChange={e => setForm({...form, price: e.target.value})} style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>最大人数</label>
                <input type="number" value={form.maxParticipants} onChange={e => setForm({...form, maxParticipants: e.target.value})} style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4 }}>年龄范围</label>
                <input value={form.ageRange} onChange={e => setForm({...form, ageRange: e.target.value})} placeholder="如: 4-12" style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingTop: 24 }}>
                <input type="checkbox" id="enableOnlinePay" checked={form.enableOnlinePayment} onChange={e => setForm({...form, enableOnlinePayment: e.target.checked})} style={{ width: 18, height: 18, cursor: 'pointer' }} />
                <label htmlFor="enableOnlinePay" style={{ fontSize: 13, color: '#666', cursor: 'pointer' }}>启用线上支付</label>
                <span style={{ fontSize: 11, color: '#999' }}>（用户报名时直接微信支付）</span>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ display: 'block', marginBottom: 4 }}>封面图</label>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <input type="file" accept="image/*" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileSelect} />
                  <button onClick={() => fileInputRef.current?.click()} 
                    style={{ padding: '6px 12px', background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 4, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    {uploading ? '上传中...' : '选择图片'}
                  </button>
                  {form.coverImage && (
                    <div style={{ position: 'relative' }}>
                      <img src={form.coverImage} alt="封面" style={{ width: 80, height: 56, objectFit: 'cover', borderRadius: 4, border: '1px solid #eee' }} />
                      <div onClick={() => setForm({...form, coverImage: ''})} 
                        style={{ position: 'absolute', top: -6, right: -6, width: 16, height: 16, borderRadius: '50%', background: '#ff4d4f', color: '#fff', fontSize: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>x</div>
                    </div>
                  )}
                  {!form.coverImage && <span style={{ fontSize: 12, color: '#999' }}>未选择封面图</span>}
                </div>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ display: 'block', marginBottom: 4 }}>活动描述</label>
                <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} rows={3} style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ display: 'block', marginBottom: 4 }}>活动亮点</label>
                <input value={form.highlights} onChange={e => setForm({...form, highlights: e.target.value})} placeholder="如: 专业指导 | 实践体验" style={{ width: '100%', padding: 8, border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
            </div>
            <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button onClick={() => setShowModal(false)} style={{ padding: '8px 16px', border: '1px solid #d9d9d9', background: '#fff', cursor: 'pointer' }}>取消</button>
              <button onClick={handleSubmit} disabled={saving} style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', cursor: 'pointer' }}>{saving ? '保存中...' : '保存'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
